export const DEVELOPMENT_ENVIRONMENT = false;

export const URL_HOST = DEVELOPMENT_ENVIRONMENT
    ? "http://localhost:5286/api/"
    : "http://www.cusalca.com/api/";

    export const FORMAT_DATE = "dd/MM/yyyy";

    export const FORMAT_TIME = "hh:mm";
    
    export const FORMAT_DATETIME = "dd/MM/yyyy HH:mm:ss";
    export const FORMAT_DATETIME_FILE = "yyyyMMdd HHmmss";
    
    export const URL_DOWNLOAD = `${URL_HOST}temps/`;

export const NO_RESULT = "No se han encontrado resultados";
export const ERROR_DATA = "Hubo un error al obtener los datos, inténtalo de nuevo más tarde.";

export const EXPORT_TITLE = "Archivo generado";
export const EXPORT_DESCRIPTION = "El archivo se ha generado correctamente, en breve se descargará.";

export const NO_SELECTED = "No seleccionado";
export const ALL = "Todos";

export const TIME_LOGIN = 10000;
export const TIME_CACHE = 3000;
export const TIME_CACHE_LONG = 60000;

export const SECONDS_TO_MILLISECONDS_COEFF = 1000;

    export const LANGUAGE = "es";

    export const APP_NAME = 'Taurel - Servicios en Linea'

export const MY_AUTH_APP = 'TaurelOnlineServiceAppContext'
export const MY_AUTH_APP_TOKEN = `${MY_AUTH_APP}_TOKEN`;
export const MY_AUTH_APP_REFRESHTOKEN = `${MY_AUTH_APP}_RefreshTOKEN`

export const UNAUTHORIZED  = 403;

export const MIN_PASSWORD_LENGTH = 8;

export const ROL_ADMINISTRATOR = "ADM";
export const ROL_CLIENT = "CLI";
export const ROL_EMPLOYEE = "EMP";
export const ROL_SHIPPING_LINE = "LN";
export const ROL_MAINTENANCE = "MTTO";
export const ROL_READ_ONLY = "LCT";

export const LAYOUT_PRIVADO = '/privado';
export const LAYOUT_PUBLICO = '/publico';

export const PATH_WEBSITE = 'https://www.taurel.com/';

export const PATH_PRIVADO = LAYOUT_PRIVADO;
export const PATH_PUBLICO = LAYOUT_PUBLICO;
export const PATH_HOME = '/inicio';
export const PATH_TERMS = '/terminos-y-condiciones';
export const PATH_CONTACT = '/contacto';
export const PATH_SERVICIOS_WEB_TRACKING = '/servicios-web-tracking';
export const PATH_SERVICIOS_POST_VENTA = '/servicios-post-venta';
export const PATH_WEB_TRACKING = `${PATH_SERVICIOS_WEB_TRACKING}/web-tracking`;
export const PATH_WEB_TRACKING_DETALLE = `${PATH_WEB_TRACKING}/detalle/:id`;
export const PATH_TRACKING_BL = `${PATH_SERVICIOS_WEB_TRACKING}/traking-bl`;
export const PATH_TRACKING_CARGA = `/tracking-carga/:id`;
export const PATH_ESTADOS_CUENTA = `${PATH_SERVICIOS_POST_VENTA}/estados-cuenta`;
export const PATH_RECLAMOS_LINEA = `${PATH_SERVICIOS_POST_VENTA}/reclamos-en-linea`;
export const PATH_RECLAMOS_LINEA_DETALLE = `${PATH_RECLAMOS_LINEA}/detalle/:codigo/:codigo1/:codigo2`;
export const PATH_REPORTE_GASTOS = `${PATH_SERVICIOS_POST_VENTA}/reporte-gastos`;
export const PATH_REPORTE_OPERATIVO = `${PATH_SERVICIOS_POST_VENTA}/reporte-operativo`;
export const PATH_INSTRUCTIVOS = `${PATH_SERVICIOS_POST_VENTA}/instructivos`;
export const PATH_USUARIOS = '/usuarios';
export const PATH_REPORTES = '/reportes';
export const PATH_LOGIN = "/iniciar-sesion"

export const MODULO_ESTADO_CUENTA = 1;
export const MODULO_RECLAMOS = 2;
export const MODULO_REPORTE_ADMINISTRATIVO = 3;
export const MODULO_REPORTE_OPERATIVO = 4;
export const MODULO_WEB_TRACKING = 5;